import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { getUserProfile } from 'helpers/userProfile';

import { Header } from '../../Analysis/Header';

export const AdminLayout = (): JSX.Element => {
  const history = useHistory();
  const [profile] = useState(getUserProfile);

  const links = [
    {
      link: '/painel/clientes/listagem',
      title: 'Empresas',
    },
  ] as {
    link: string;
    title: string;
    prefix?: string;
  }[];

  if (!profile.permissions.isAdminConta) {
    links.push({
      link: '/painel/cidades',
      title: 'Cidades',
    });
    links.push({
      link: '/painel/falhas/dac',
      prefix: '/painel/falhas/',
      title: 'Falhas',
    });
    links.push({
      link: '/painel/dut-ir',
      title: 'DUT IR',
    });
    links.push({
      link: '/painel/devlogs',
      title: 'Logs',
    });
    links.push({
      link: '/painel/firmware',
      title: 'Firmware',
    });
    links.push({
      link: '/painel/simCards?empresa=todos',
      title: 'SIMCARDS',
    });
    links.push({
      link: '/painel/integracoes',
      title: 'Integrações',
    });
  }
  if (profile.permissions.isAdminSistema) {
    links.push({
      link: '/painel/fabricantes',
      title: 'Fabricantes',
    });
    links.push({
      link: '/painel/sensores',
      title: 'Sensores',
    });
    links.push({
      link: '/painel/servers-monitoring',
      title: 'Servidores',
    });
    links.push({
      link: '/painel/ferramentas-diel',
      title: 'Ferramentas Diel',
    });
    links.push({
      link: '/painel/projeto-bb/kpis',
      prefix: '/painel/projeto-bb/',
      title: 'Projeto BB',
    });
    links.push({
      link: '/painel/horario-verao',
      prefix: '/painel/horario-verao/',
      title: 'Horario de Verão',
    });
    links.push({
      link: '/painel/historico-controle',
      prefix: '/painel/historico-controle/',
      title: 'Histórico Controle',
    });
  }
  if (profile.isMasterUser || history.location.pathname.endsWith('/painel/devtools')) {
    links.push({
      link: '/painel/devtools',
      title: 'DevTools',
    });
  }
  if (profile.isMasterUser || history.location.pathname.endsWith('/painel/analise-automacao-grupos')) {
    links.push({
      link: '/painel/analise-automacao-grupos',
      title: 'Análise Automação',
    });
  }

  return (
    <Header links={links} />
  );
};

export const ClientLayout = (): JSX.Element => {
  const links = [
    {
      link: '/painel/client-painel',
      title: 'Empresa',
    },
    {
      link: '/painel/historico-controle',
      prefix: '/painel/historico-controle',
      title: 'Histórico Controle',
    },
  ];

  return (
    <Header links={links} />
  );
};
